import React, { useState, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupHeading } from "../../../components/UI/Heading";
import SupXSmall from "../../../icons/XSmall";

interface AlertBarProps {
  visible?: boolean;
  icon?: JSX.Element;
  suffix?: JSX.Element;
  message?: string;
  className?: string;
  color?: "info" | "warning" | "success" | "error";
  closeable?: boolean;
  onClose?: () => void;
}

// const ALERT_BAR_COLORS = {
//   info: "bg-info-200 text-neutral-900",
//   warning: "bg-warning-600 text-neutral-50",
//   success: "bg-success-600 text-neutral-50",
//   error: "bg-error-700 text-neutral-50",
// } as const;
const ALERT_BAR_COLORS = {
  info: "bg-info-800 text-info-50",
  warning: "bg-warning-800 text-warning-50",
  success: "bg-success-800 text-success-50",
  error: "bg-error-400 text-error-975",
} as const;

export function SupIndicatorAlertBar({ visible: visibilityProp = true, icon, message, className, suffix, color = "info", closeable = true, onClose }: AlertBarProps) {
  const [visible, setVisibility] = useState(true);

  const handleClose = () => {
    onClose?.();
    setVisibility(false);
  };

  return visible && visibilityProp ? (
    <div className={twMerge("sup-indicator-alert-bar flex items-center h-[3.75rem] px-4 gap-4", ALERT_BAR_COLORS[color], className)}>
      {icon && <div className="inline-flex justify-center items-center shrink-0 w-10">{icon}</div>}
      <div className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden">
        {message && (
          <SupHeading as="span" variant="h6">
            {message}
          </SupHeading>
        )}
      </div>
      {suffix && <div className="inline-flex justify-center items-center shrink-0">{suffix}</div>}
      {closeable && (
        <div className="inline-flex justify-center items-center shrink-0 w-10">
          <button type="button" onClick={handleClose}>
            <SupXSmall />
          </button>
        </div>
      )}
    </div>
  ) : null;
}
